import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { BulkSyncResponseModel } from "../../../app/models/BulkSyncResponseModel";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import BulkSyncBox from "./BulkSyncBox";
import AjaxLoader from "../../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function BulkSyncPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [bulkSync, setBulkSync] = useState<BulkSyncResponseModel>();
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  useEffect(() => {
    setIsLoading(true);
    apiAgent.Admin.getBulkSync()
      .then((response: BulkSyncResponseModel) => {
        let oBulkSync: BulkSyncResponseModel = response;
        setBulkSync(oBulkSync);
        //console.log("bulk Sync", oBulkSync);
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  document.title = "Base - Bulk Sync";

  if (isLoading) {
    return <AjaxLoader />;
  } else if (!isLoading && bulkSync) {
    return (
      <>
        <div className="container-fluid">
          <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Bulk Sync" }]} />

          <div className="row">
            <div className="hidden-sm col-md-2"></div>
            <div id="content" className="col-sm-12 col-md-8">
              <BulkSyncBox portalDD={bulkSync.portalDD} officeDD={bulkSync.officeDD} />
            </div>
            <div className="hidden-sm col-md-2"></div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
});
